<!--   平台运维-服务器管理 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea ServerManage">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 预存信息 -->
        <div class="prestoreArea">
          <span class="text">上次预存时间：{{serverData.feeInfo.server_operation_date === '' ? '还未有预存过' : serverData.feeInfo.server_operation_date}}</span>
          <span class="text">上次预存费用：{{serverData.feeInfo.server_pre_fee === '' ? 0 : serverData.feeInfo.server_pre_fee}}元</span>
          <el-button type="primary" plain @click="operateDialogInfo('alterPrestore')">修 改</el-button>
          <el-button type="info" plain @click="operateDialogInfo('prestoreRecord')">预存记录</el-button>
        </div>
        <!-- 内容左边区域 -->
        <div class="contentLeftArea">
          <!-- 添加服务器组 -->
          <div class="addDeviceArea clearfix">
            <span class="text">服务器组</span>
            <i class="icon el-icon-circle-plus-outline" @click="operateDialogInfo('addServerGroup')"></i>
          </div>
          <!-- 部门列表 -->
          <el-tree
            class="defineTree"
            v-loading="serverGroupData.loading"
            :data="serverGroupData.list"
            node-key="category_id"
            default-expand-all
            :props="defaultProps" >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <!-- 自定义icon -->
              <i
                class="defineIcon"
                :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
              </i>
              <span
                :class="data.category_id === serverGroupData.selected ? 'selected' : ''"
                class="label"
                @click="groupNodeClick(data)">{{ node.label }}</span>
              <!-- 修改、删除 -->
              <span
                class="operate"
                v-show="node.level !== 1">
                <span class="text el-icon-edit-outline" @click="operateDialogInfo('alterServerGroup', data, node.id)"></span>
                <span class="text el-icon-delete" @click="operateDialogInfo('deleteServerGroup', data, node.id)"></span>
              </span>
            </span>
          </el-tree>
          <!-- 部门列表为空 -->
          <p class="contentNull" v-show="serverGroupData.list.length === 0">还未添加分类</p>
        </div>

        <!-- 内容右边区域 -->
        <div class="contentRightArea">
          <!-- 添加按钮 -->
          <el-button type="primary" class="add" @click="operateServer('addServer')">添 加</el-button>
          <!-- 选择框 -->
          <el-checkbox class="check" v-model="serverData.checked">显示状态为停用的服务器</el-checkbox>

          <!-- 服务器列表 -->
          <el-table
            class="serverList"
            v-loading="serverData.loading"
            :data="serverData.list"
            style="width: 100%">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-form label-position="left" inline class="expandForm">
                  <el-form-item label="配置">
                    <span>{{ props.row.server_config }}</span>
                  </el-form-item>
                  <el-form-item label="用途">
                    <span>{{ props.row.server_use }}</span>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column
              class-name="textAlignLeft"
              label="服务器名称"
              prop="server_name"
              sortable>
            </el-table-column>
            <el-table-column
              label="服务器地址"
              prop="server_ip">
            </el-table-column>
            <el-table-column
              label="费用">
              <template slot-scope="scope">
                <p class="text">{{scope.row.server_cost}}/{{scope.row.server_is_yorm === '1' ? '年' : '月'}}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="使用期限"
              prop="server_date"
              width="195">
            </el-table-column>
            <el-table-column
              label="计划时间">
              <template slot-scope="scope">
                <p class="text">{{scope.row.server_plan_date === null ? '/' : scope.row.server_plan_date}}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="使用状态">
              <template slot-scope="scope">
                <el-button type="text" @click="operateDialogInfo('changeState',scope.row)">{{scope.row.server_is_stop === '1' ? '停用' : '启用'}}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="operateServer('alterServer', scope.row)">修改</el-dropdown-item>
                    <el-dropdown-item @click.native="operateDialogInfo('addPlan',scope.row)">计划</el-dropdown-item>
                    <el-dropdown-item @click.native="operateDialogInfo('serverRecord', scope.row)">记录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <el-button type="text" @click="operateServer('alterServer', scope.row)">修改</el-button>
                <el-button type="text" @click="operateDialogInfo('addPlan',scope.row)">计划</el-button>
                <el-button type="text" @click="operateDialogInfo('serverRecord', scope.row)">记录</el-button> -->
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="paging">
            <el-pagination
              @size-change="sizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="serverData.paging.page"
              :page-sizes="[10, 100, 1000]"
              :page-size.sync="serverData.paging.perPage"
              layout="sizes, prev, pager, next"
              :page-count="serverData.pageCount">
            </el-pagination>
          </div>
        </div>
        

        <!-- 对话框 -->
        <el-dialog
          :class="dialogData.type === 'serverRecord' ? 'dialogTable' : ''"
          :title="dialogData.title" 
          :visible.sync="dialogData.visible"
          :show-close="dialogData.title === '' ? false : true">
          
          <!-- 状态 -->
          <div
            class="changeStatusWrapper"
            v-if="dialogData.type === 'changeState'">
            <p class="text">
              当前客户状态为
              <span class="bold">
                {{dialogData.info.server_is_stop === '1' ? '停用' : '启用'}}
              </span>
            </p>
            <p class="text">
              是否将状态改为
              <span class="bold">
                {{dialogData.info.server_is_stop === '1' ? '启用' : '停用'}}？
              </span>
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="changeServerState()">{{dialogData.info.server_is_stop === '1' ? '启用' : '停用'}}</el-button>
            </div>
          </div>

          <!-- 计划 -->
          <div
            class="addPlanWrapper"
            v-else-if="dialogData.type === 'addPlan'">
            
            <el-form
              label-width="80px"
              :model="dialogData.info">
              <el-form-item label="类型:">
                <div class="inputBox">
                  <el-select class="inputDeposit" v-model="dialogData.info.server_serial_type">
                    <el-option label="计划" value="1"></el-option>
                    <el-option label="计划结束" value="2"></el-option>
                    <el-option label="费用" value="3"></el-option>
                    <el-option label="其他" value="4"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <!-- 选中费用 -->
              <div class="feeSelected" v-if="dialogData.info.server_serial_type === '3'">
                <el-form-item label="费用:">
                  <div class="inputBox clearfix">
                    <el-select class="feeSelect" v-model="dialogData.info.server_fee_yorm">
                      <el-option label="月" value="1"></el-option>
                      <el-option label="年" value="2"></el-option>
                    </el-select>
                    <el-input class="fee"  v-model="dialogData.info.server_fee"></el-input>元
                  </div>
                </el-form-item>
                <el-form-item label="使用期限:">
                  <div class="inputBox">
                     <el-date-picker
                      class="inputDeposit"
                      v-model="dialogData.info.server_date"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                    </el-date-picker>
                  </div>
                </el-form-item>
              </div>
              <!-- 选中费用不显示 -->
              <el-form-item label="备注:" v-else>
                <div class="inputBox">
                  <el-input class="inputDeposit" type="textarea" rows="4" v-model="dialogData.info.server_operation_explain"></el-input>
                </div>
              </el-form-item>

              <!-- 选中计划 -->
              <el-form-item label="计划时间:" v-if="dialogData.info.server_serial_type === '1'">
                <div class="inputBox">
                  <el-date-picker
                    class="inputDeposit"
                    v-model="dialogData.info.server_serial_next"
                    type="date"
                    placeholder="请选择日期">
                  </el-date-picker>
                </div>
              </el-form-item>

            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button @click="addServerPlan()">确认</el-button>
              <el-button @click="dialogData.visible = false">取消</el-button>
            </div>
          </div>

          <!-- 服务器记录列表 -->
          <div
            v-else-if="dialogData.type === 'serverRecord'">
            <!-- 记录列表 -->
            <el-table
              v-loading="serverData.serverRecord.loading"
              :data="serverData.serverRecord.list"
              style="width: 100%"
              border>
              <el-table-column
                type="index"
                label="序号">
              </el-table-column>
              <el-table-column
                prop="server_serial_type_name"
                label="类型">
              </el-table-column>
              <el-table-column
                label="计划时间">
                <template slot-scope="scope">
                  <p class="text">{{scope.row.server_serial_type === '1' ? scope.row.server_serial_next : '/'}}</p>
                  <!-- <p class="text">{{scope.row.server_serial_next}}</p> -->
                </template>
              </el-table-column>
              <el-table-column
                label="备注">
                <template slot-scope="scope">
                  <p class="text">{{scope.row.server_serial_type === '3' ? '/' : scope.row.server_operation_explain}}</p>
                </template>
              </el-table-column>
              <el-table-column
                label="费用">
                <template slot-scope="scope">
                  <p class="text" v-if="scope.row.server_serial_type === '3'">{{scope.row.server_fee}}/{{scope.row.server_is_yorm === '1' ? '年' : '月'}}</p>
                  <p class="text" v-else>/</p>
                </template>
              </el-table-column>
              <el-table-column
                label="使用期限"
                width="200">
                <template slot-scope="scope">
                  <p class="text">{{scope.row.server_serial_type === '3' ? scope.row.server_date : '/' }}</p>
                </template>
              </el-table-column>
              <el-table-column
                prop="server_operation_date"
                label="修改时间"
                width="170">
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="paging" v-if="serverData.serverRecord.list.length !== 0">
              <el-pagination
                @current-change="recordPageChange"
                :current-page.sync="serverData.serverRecord.paging.page"
                layout="prev, pager, next, jumper"
                :page-count="serverData.serverRecord.pageCount">
              </el-pagination>
            </div>
          </div>

          <!-- 修改预存金额 -->
          <div
            class="prestoreDialog"
            v-else-if="dialogData.type === 'alterPrestore'">
            <el-form
              label-width="80px"
              :model="dialogData.info">
              <el-form-item label="预存金额:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.money"></el-input>元
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="modifyFee">确 认</el-button>
            </div>
          </div>

          <!-- 预存记录 -->
          <div
            v-else-if="dialogData.type === 'prestoreRecord'">
            <el-table
              v-loading="prestoreData.loading"
              :data="prestoreData.list"
              style="width: 100%"
              border>
              <el-table-column
                type="index"
                label="序号"
                width="50">
              </el-table-column>
              <el-table-column
                prop="server_pre_fee"
                label="费用">
              </el-table-column>
              <el-table-column
                prop="server_operation_date"
                label="预存时间">
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="paging" v-if="prestoreData.list.length !== 0">
              <el-pagination
                @current-change="prestorePageChange"
                :current-page.sync="prestoreData.paging.page"
                layout="prev, pager, next, jumper"
                :page-count="prestoreData.pageCount">
              </el-pagination>
            </div>
          </div>

           <!-- 添加/修改服务器组 -->
          <div 
            v-else-if="dialogData.type === 'addServerGroup' || dialogData.type === 'alterServerGroup'">
            <el-form
              ref="serverGroupDio"
              label-width="120px"
              :model="dialogData.info">
              <el-form-item label="服务器组名称:" prop="name" :rules="[{ required: true, message: '请输入服务器组名称', trigger: 'blur' }]">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.name"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="服务器组类型:" prop="network_type" :rules="[{ required: true, message: '请选择服务器组类型', trigger: 'blur' }]">
                <div class="inputBox">
                  <el-select class="inputDeposit" placeholder="请选择服务器组类型" v-model="dialogData.info.network_type" clearable>
                    <el-option :label="item" :value="index" v-for="(item, index) in networkTypeList" :key="index"></el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="updateServerCategory">确 认</el-button>
            </div>
          </div>

          <!-- 删除服务器组 -->
          <div
            class="changeStatusWrapper"
            v-if="dialogData.type === 'deleteServerGroup'">
            <p class="text">删除后，该组的所有服务器将移至全部！</p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="deleteServerCategory()">确 认</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../../Layout/BreadCrumb.vue"
  import { storage, updataBreadCrumb, showToast, deepCopy } from "../../../../../static/js/utility/utility.js"
  import { maintainApi } from "../../../../../static/js/api.js"
  import { getNowDate } from '../../../../../static/js/utility/date'

  export default {
    name: 'ServerManage',
    components: {
      BreadCrumb
    }, 
    data() {
      return {
        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          info: {}
        },
        // 服务器组信息
        serverGroupData: {
          list: [
            {
              name: '全部',
              category_id: '',
              children: []
            }
          ],
          loading: false,
          // 默认选中全部
          selected: ''
        },
        networkTypeList: {}, // 服务器组类型列表
        // 服务器数据
        serverData: {
          checked: false,
          // 分页数据  page为当前页，perPage为每页数量 ,state为服务器状态,1显示服务器启用状态,不填则显示全部
          paging: {
            page: 1,
            perPage: 10,
            state: ''
          },
          // 服务器列表
          list:[],
          loading: false,
          // 预存信息
          feeInfo: {},
          // 服务器记录列表
          serverRecord: {
            // 分页数据  page为当前页，perPage为每页数量 
            paging: {
              page: 1,
              perPage: 10
            },
            list: [],
            loading: false
          }
        },
        // 预存记录
        prestoreData: {
          // 分页数据  page为当前页，perPage为每页数量
          paging: {
            page: 1,
            perPage: 10
          },
          // 预存记录列表
          list: [],
          loading: false
        },
        // 树形控件配置
        defaultProps: {
          children: 'children',
          label: 'name'
        }
      }
    },
    mounted(){
      this.getServerCategoryList()
      this.getNetworkTypeList()
    },
    created () {},
    methods: {
      // 操作对话框信息（添加或修改）dialogData
      operateDialogInfo (type, info) {
        console.log('type', type)
        // 计划信息
        let planInfo
        if (type === 'addPlan') {
          // 默认选中计划，费用为月
          planInfo = {
            server_id: info.server_id,
            server_serial_type: '1',
            server_serial_next: '',
            server_operation_explain: '',
            server_fee: '',
            server_fee_yorm: '1',
            server_date: ''
          }
        }
        // 修改预存信息
        let prestoreInfo = {
          money: ''
        }
        // 添加服务器组信息
        let addServerGroupInfo = {
          name: '',
          network_type: ''
        }

        // console.log('planInfo', planInfo) addServerGroup
        let title = type === 'addPlan' ? '计划' :
                    type === 'serverRecord' ? '记录' :
                    type === 'alterPrestore' ? '修改'  :
                    type === 'prestoreRecord' ? '预存记录' :
                    type === 'addServerGroup' ? '添加服务器组' :
                    type === 'alterServerGroup' ? '修改服务器组' :
                    type === 'deleteServerGroup' ? '删除服务器组' : ''
        this.dialogData = {
          type: type,
          title: title,
          visible: !(this.dialogData.visible),
          isReset: false,
          info: type === 'addPlan' ? planInfo :
                type === 'alterPrestore' ? prestoreInfo :
                type === 'addServerGroup' ? addServerGroupInfo :
                type === 'prestoreRecord' ? '' : deepCopy(info)
        }

        // 对话框显示服务器记录列表
        if(type === 'serverRecord') {
          this.getServerPlanList()
        } else if (type === 'prestoreRecord') {
          this.getFeeList()
        }
        console.log('this', this.dialogData)
      },
      // 获取服务器组列表
      async getServerCategoryList () {
        let vm = this

        vm.serverGroupData.loading = true
        let res = await maintainApi.getServerCategoryList()
        vm.serverGroupData.loading = false
        if (res.meta.code === 200) {
          vm.serverGroupData.list[0].children = res.data
          vm.getServerList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取网络类型列表
      async getNetworkTypeList () {
        let vm = this
        let res = await maintainApi.getServerCategoryNetworkTypeList()
        if (res.meta.code === 200) {
          vm.networkTypeList = res.data
        } else {
          showToast(res.meta.message)
        }
      },
      // 更新（添加/修改）服务器组
      async updateServerCategory () {
        let vm = this
        vm.$refs['serverGroupDio'].validate(async (valid) => {
          if (valid) {
            vm.serverGroupData.selected = vm.dialogData.info.category_id ? vm.dialogData.info.category_id : vm.serverGroupData.selected
            let data = {
              name: vm.dialogData.info.name,
              network_type: vm.dialogData.info.network_type,
              category_id: vm.dialogData.info.category_id ? vm.dialogData.info.category_id : '',
            }

            let res = await maintainApi.updateServerCategory(data)
            console.log('data', data)
            if (res.meta.code === 200) {
              showToast((vm.dialogData.type === 'addServerGroup' ? '添加' : '修改') + '成功')
              vm.dialogData.visible = !(vm.dialogData.visible)
              vm.getServerCategoryList()
            } else {
              showToast(res.meta.message)
            }
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      // 删除服务器组
      async deleteServerCategory () {
        let vm = this
        let data = {
          category_id: vm.dialogData.info.category_id
        }

        let res = await maintainApi.deleteServerCategory(data)
        console.log('data', data)
        if (res.meta.code === 200) {
          showToast('删除成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.serverGroupData.selected = ''
          vm.getServerCategoryList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 处理服务器列表数据
      processServerData (data) {
        let vm = this
        let list = data.list

        for (let i in list) {
          list[i].server_date = data.list[i].server_begin_date + ' ~ ' + data.list[i].server_end_date
        }
        
        vm.serverData.list = list
        vm.serverData.feeInfo = data.feeInfo
        vm.serverData.pageCount = data.pageCount
        // console.log('vm.serverData.list', vm.serverData.list)
        vm.$forceUpdate()
      },
      // 获取服务器列表
      async getServerList (check) {
        let vm = this
        // state为服务器状态,1显示服务器启用状态,不填则显示全部
        let data = vm.serverData.paging
        data.server_category_id = vm.serverGroupData.selected
        data.state = vm.serverData.checked ? '1' : ''
        if (check) {
          data.page = 1
        }
        console.log('vm.serverData.paging', vm.serverData.paging)
        console.log('data', data, check)

        vm.serverData.loading = true
        let res = await maintainApi.getServerList(data)
        vm.serverData.loading = false
        if (res.meta.code === 200) {
          vm.processServerData(res.data)
        } else {
          showToast(res.meta.message)
        }
        // console.log('服务器列表', vm.serverData.list)
      },
      // 点击树形节点获取服务器列表
      groupNodeClick (data, node, e) {
        console.log('data', data, node,e)
        this.serverGroupData.selected = data.category_id
        this.getServerList('new')
      },
      // 每页显示数量变化，获取新的协议列表
      sizeChange (val) {
        console.log(`每页 ${val} 条`);
        this.getServerList()
      },
      // 服务器列表当前页值改变，获取新的服务器列表
      handleCurrentChange (val) {
        console.log(`当前页: ${val}`);
        console.log('vm.serverData.paging', this.serverData.paging)
        this.getServerList()
      },
      // 修改服务器状态
      async changeServerState () {
        let vm = this
        let data = {
          server_id: vm.dialogData.info.server_id
        }

        let res = await maintainApi.changeServerState(data)
        if (res.meta.code === 200) {
          showToast('修改状态成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getServerList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 新增服务器计划
      async addServerPlan () {
        let vm = this
        let type = vm.dialogData.info.server_serial_type
        let server_date = vm.dialogData.info.server_date
        let server_serial_next = vm.dialogData.info.server_serial_next
        let data = {
          server_id: vm.dialogData.info.server_id,
          server_serial_type: type,
          server_operation_explain: vm.dialogData.info.server_operation_explain,
          server_fee: vm.dialogData.info.server_fee,
          server_fee_yorm: vm.dialogData.info.server_fee_yorm,
          server_serial_next: server_serial_next === '' ? '' : getNowDate(server_serial_next),
          server_begin_date: server_date === '' ? '' : getNowDate(server_date[0]),
          server_end_date: server_date === '' ? '' : getNowDate(server_date[1])
        }

        console.log('data', data)
        // return
        
        if (type === '3') {
          // 选中费用判断
          if (data.server_fee === '') {
            showToast('请填写费用！')
            return
          }
          if (data.server_date === '') {
            showToast('请选中使用期限！')
            return
          }
        } else {
          if (data.server_operation_explain === '') {
            showToast('请填写备注！')
            return
          }
          if (type === '1') {
            if (data.server_serial_next === '') {
              showToast('请选择计划时间！')
              return
            }
          }
        }

        let res = await maintainApi.addServerPlan(data)
        if (res.meta.code === 200) {
          showToast('添加计划成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getServerList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取服务器记录列表
      async getServerPlanList () {
        let vm = this
        let data = vm.serverData.serverRecord.paging
        data.server_id = vm.dialogData.info.server_id
        console.log('data', data)

        vm.serverData.serverRecord.loading = true
        let res = await maintainApi.getServerPlanList(data)
        vm.serverData.serverRecord.loading = false
        if (res.meta.code === 200) {
          let list = res.data.list
          for (let i in list) {
            list[i].server_date = list[i].server_begin_date + ' ~ ' + list[i].server_end_date
            let type = list[i].server_serial_type
            list[i].server_serial_type_name = type === '1' ? '计划' : type === '2' ? '计划结束' : type === '3' ? '续费' : '其他'  
          }
          vm.serverData.serverRecord.list = list
          vm.serverData.serverRecord.pageCount = res.data.pageCount
        } else  {
          showToast(res.meta.message)
        }
      },
      // 服务器记录列表当前页值改变，获取新的服务器记录列表
      recordPageChange (val) {
        console.log(`当前页: ${val}`);
        this.getServerPlanList()
      },
      // 修改预存金额
      async modifyFee () {
        let vm = this
        let data = vm.dialogData.info
        
        if (data.money === '') {
          showToast('请填写预存金额！')
          return
        }
        let res = await maintainApi.modifyFee(data)
        if (res.meta.code === 200) {
          showToast('修改成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getServerList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取预存记录列表
      async getFeeList () {
        let vm = this
        let data = vm.prestoreData.paging

        vm.prestoreData.loading = true
        let res = await maintainApi.getFeeList(data)
        vm.prestoreData.loading = false
        if (res.meta.code === 200) {
          vm.prestoreData.list = res.data.list
          vm.prestoreData.pageCount = res.data.pageCount
        } else {
          showToast(res.meta.message)
        }
      },
      // 预存记录列表当前页值改变，获取新的预存记录列表
      prestorePageChange (val) {
        console.log(`当前页: ${val}`);
        this.getFeeList()
      },
      // 去操作服务器页面
      operateServer (type, serverInfo) {
        let vm = this
        let addNavBarActive = [], query = {}
        if (type === 'alterServer') {
          // 修改服务器
          addNavBarActive = [{function_tab: "OperateServer", function_name: "修改服务器"}]
          query = {server_id: serverInfo.server_id}
        } else {
          // 添加服务器
          addNavBarActive = [{function_tab: "OperateServer", function_name: "添加服务器"}]
          query = vm.serverGroupData.selected !== '' ? {server_category_id: this.serverGroupData.selected} : {}
        }

        // 更新面包屑内容
        updataBreadCrumb(3, addNavBarActive)
        this.$router.push({
          path: '/OperateServer',
          query
        })
      }
    },
    watch: {
      // 监听服务器组是否发生变化
      'serverGroupData.selected': function (newVal) {
        console.log('newVal', newVal)
        this.getServerCategoryList()
      },
      // 监听是否只显示禁用选择框，选中则为true
      'serverData.checked': function (newVal) {
        // console.log('newval', newVal)
        this.getServerList('check')      
      },
      // 监听计划类型变化,清空上一次填写信息
      'dialogData.info.server_serial_type': function (newVal) {
        console.log('当前类型', newVal)
        this.dialogData.info.server_operation_explain = ''
        this.dialogData.info.server_fee = ''
        this.dialogData.info.server_fee_yorm = '1'
        this.dialogData.info.server_serial_next = ''
        this.dialogData.info.server_date = ''
      }
    }
  }
</script>

<style lang="scss" scoped>
.ServerManage {
  .mainBodyContent::after{
    height: calc(100% - 63px);
    content: '';
    border-right: 1px solid #E4E7ED;
    position: absolute;
    left: 250px;
    top: 63px;
  }
  .mainBodyContent{
    padding: 0;
    position: relative;
    // 预存信息
    .prestoreArea {
      padding: 10px;
      border-bottom: 1px solid #E4E7ED;
      .text {
        display: inline-block;
        line-height: 40px;
        font-size: 16px;
        font-weight: bold;
        margin-right: 30px;
      }
    }
    .contentLeftArea {
      float: left;
      width: 250px;
      // 添加
      .addDeviceArea{
        width: 100%;
        line-height: 40px;
        padding: 0 20px 0 10px;
        border-bottom: 1px solid #E4E7ED;
        .text{
          float: left;
        }
        .icon {
          float: right;
          display: block;
          font-size: 20px;
          line-height: 40px;
        }
      }
      // 树形控件
      .defineTree {
        .operate {
          .text {
          font-size: 18px;
          }
        }
      }
    }
    .contentRightArea {
      padding: 20px;
      margin-left: 260px;
      .add,.check{
        margin-bottom: 22px;
      } 
      .add {
        margin-right: 30px;
      }
      .serverList {
        .expandForm {
          width: 100%;
          .el-form-item {
            width: 100%;
            margin: 0;
          }
        }
      }
    }
    // 对话框
    .addPlanWrapper {
      .inputDeposit {
        width: 100%;
      }
      .feeSelected{
        .feeSelect{
          width: 30%;
          float: left;
          margin-right: 8%;
        }
        .fee {
          width: 50%;
          margin-right: 5%;
        }
      }
    }
    .prestoreDialog .inputDeposit {
      width: 270px;
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/Maintain/ServerManage/SIndex.vue